import React from "react";
import ReactDOM from "react-dom/client";
import "swiper/css";
import "swiper/css/navigation";

import "./index.css";
import "./assets/css/style.scss";

import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "./contexts";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { ErrorContext } from "./contexts/error";
import { GasFeeProvider } from "./contexts/gasFee";
import { TwoFA } from "./components/TwoFA";
import { SocialEmail } from "./components/SocialEmail";
import { FacebookProvider } from "react-facebook";
import { GoogleOAuthProvider } from "@react-oauth/google";
import environment from "./environment";
import VerifyPhone from "./components/VerifyPhone";
if (!(!process.env.NODE_ENV || process.env.NODE_ENV === "development")) {
  Sentry.init({
    dsn: "https://56b331cd63494c969ab4386d5ddd7e16@o4505091176464384.ingest.sentry.io/4505091278307328",
    integrations: [new BrowserTracing()],
    tracesSampler: samplingContext => {
      const name = samplingContext.transactionContext?.name || '';
      if (name.startsWith('pageload') && name.includes('/')) return 0.1;
      return 1.0;
    },
  });
  console.log("Sentry inited!");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <FacebookProvider appId={environment.FB_APP_ID}>
    <ErrorContext>
      <BrowserRouter>
          <GoogleOAuthProvider clientId={environment.GOOGLE_CLIENT_ID}>
              <AppProvider>
                <GasFeeProvider>
                  <AppRouter />
                  <TwoFA />
                  <SocialEmail />
                  <VerifyPhone />
                </GasFeeProvider>
              </AppProvider>
          </GoogleOAuthProvider>
      </BrowserRouter>
    </ErrorContext>
  </FacebookProvider>
);

reportWebVitals();
